import Phaser from 'phaser';
import { createIconHud } from '../ui/IconHud';
import { SynthSfx } from '../audio/SynthSfx';

export class WinScene extends Phaser.Scene {
  constructor() {
    super('Win');
  }

  preload() {
    this.load.image('win', 'assets/win.png');
  }

  create() {
    createIconHud(this);
    SynthSfx.win();

    this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x060814, 0.55).setOrigin(0);
    const img = this.add.image(this.scale.width / 2, this.scale.height / 2, 'win');
    const scale = Math.min(this.scale.width / img.width, this.scale.height / img.height) * 0.92;
    img.setScale(scale);

    this.add.text(this.scale.width / 2, 72, 'Misión lunar completa', {
      fontFamily: 'monospace',
      fontSize: '30px',
      color: '#ffffff',
    }).setOrigin(0.5);

    this.add.text(this.scale.width / 2, 112, 'Subiste al cohete, llegaste a la Luna y perforaste hasta el núcleo.', {
      fontFamily: 'monospace',
      fontSize: '16px',
      color: '#eef6ff',
      wordWrap: { width: Math.min(520, this.scale.width - 48) },
      align: 'center',
    }).setOrigin(0.5);

    const restart = this.add.text(this.scale.width / 2, this.scale.height - 76, 'JUGAR OTRA VEZ', {
      fontFamily: 'monospace',
      fontSize: '26px',
      color: '#0a111f',
      backgroundColor: '#f5d66f',
      padding: { left: 12, right: 12, top: 8, bottom: 8 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    restart.on('pointerdown', () => {
      this.scene.start('Pad');
    });
  }
}
